import {
  Icon,
  MessageBarType,
  SearchBox, Stack,
} from '@fluentui/react';
import React from 'react';
import {
  Link,
} from 'react-router-dom';
import MessageBar from '../../../../shared/MessageBar';
import tokens from '../../../../shared/StackTokens';
import ConfigReducer from '../../../../shared/state/ConfigReducer';
import Store from '../../../../shared/state/Store';
import OutputItem from './OutputItem';
import Routing from '../../../../shared/Routing';
import Utils from '../../../../shared/Utils';

export default () => {
  const [globalState] = Store.useStore();
  const routingTree = Routing.getTree(globalState).home;

  const [filter, setFilter] = React.useState('');
  const [items, setItems] = React.useState([]);

  const filterItems = () => {
    const outputConfig = ConfigReducer.getOutputConfig(globalState);
    const fItems = [];
    outputConfig.forEach((group) => {
      group.items.forEach((groupItem) => {
        let keep = true;
        if (filter && filter.trim() !== '') {
          const toString = `${groupItem.node}${groupItem.label}`;
          keep = toString.toLowerCase().indexOf(filter) >= 0;
        }
        if (keep) {
          const key = Utils.createNetworkNodeKey(groupItem.network, groupItem.node);

          fItems.push(
            <OutputItem
              key={key}
              groupItem={groupItem}
              groupName={group.groupName}
            />,
          );
        }
      });
    });
    setItems(fItems);
  };

  React.useEffect(() => {
    filterItems();
  }, [filter, globalState.outputConfigMap]);

  return (
    <Stack vertical tokens={tokens.verticalSpacing} style={{ paddingTop: '10px' }}>
      <MessageBar
        messageBarType={MessageBarType.warning}
        styles={{ container: { width: 'fit-content' } }}
        isMultiline
        text={(
          <>
            You can also configure individual output items right from the
            {' '}
            <Link to={routingTree.routes.webAppDesigner.routes.preview.path}>Preview</Link>
            {' '}
            interface by clicking the
            {' '}
            <Icon iconName="Settings" style={{ position: 'relative', top: '2px' }} />
            {' '}
            button at the top of the output item
          </>
)}
      />
      <div
        style={{
          width: '200px',
        }}
      >
        <SearchBox
          placeholder="Filter by label or ID"
          type="search"
          iconProps={{
            iconName: 'Filter',
          }}
          onChange={(ev, newValue) => setFilter(newValue.toLowerCase())}
          onSearch={(newValue) => setFilter(newValue.toLowerCase())}
          onEscape={() => {
            setFilter('');
          }}
          onClear={() => {
            setFilter('');
          }}
          value={filter}
        />
      </div>

      <Stack horizontal wrap disableShrink tokens={tokens.spacing}>
        {items}
      </Stack>
    </Stack>

  );
};
